import { Controller } from "@hotwired/stimulus"

const debug = true
export default class extends Controller {
  static targets = ["link"]
  static values = {
    default: String,
    active: String
  }

  connect() {
    this.onScroll = this.onScroll.bind(this)
    document.addEventListener("scroll", this.onScroll, { passive: true })
    this.onScroll()
  }

  disconnect() {
    document.removeEventListener("scroll", this.onScroll)
  }

  onScroll() {
    const viewportTop = window.scrollY
    const viewportThreshold = viewportTop + window.innerHeight / 3

    let currentLink = null
    let closestTop = -Infinity

    this.linkTargets.forEach((link) => {
      const targetId = link.getAttribute("href")?.slice(1)
      if (!targetId) return

      const targetElement = document.getElementById(targetId)
      if (!targetElement) return

      const targetTop = targetElement.getBoundingClientRect().top + window.scrollY

      if (targetTop <= viewportThreshold && targetTop > closestTop) {
        closestTop = targetTop
        currentLink = link
      }
    })

    if (currentLink) this.doHighlight(currentLink)
  }

  highlight(event) {
    this.doHighlight(event.currentTarget)
  }

  doHighlight(currentLink) {
    const defaultClasses = this.defaultValue.trim().split(/\s+/).filter(Boolean)
    const activeClasses = this.activeValue.trim().split(/\s+/).filter(Boolean)

    this.linkTargets.forEach((link) => {
      if (link === currentLink) {
        if (debug) console.info(`Added active classes to link::${link.href}`)
        link.classList.remove(...defaultClasses)
        link.classList.add(...activeClasses)
      } else {
        if (debug) console.info(`Removing active classes to link::${link.href}`)
        link.classList.remove(...activeClasses)
        defaultClasses.forEach((className) => {
          if (!link.classList.contains(className)) {
            link.classList.add(className)
          }
        })
      }
    })
  }
}